import { getDepthBotConstants } from '../constants';

const getDepthBot = (state, action) => {
    if (state === undefined) {
        return {
            depthBots: [],
            loading: true,
            error: false,
        };
    }

    switch (action.type) {
        case getDepthBotConstants.GET_DEPTH_BOT_REQUEST:
            return {
                depthBots: [],
                loading: true,
                error: false,
            };

        case getDepthBotConstants.GET_DEPTH_BOT_SUCCESS:
            return {
                depthBots: action.payload,
                loading: false,
                error: false,
            };

        case getDepthBotConstants.GET_DEPTH_BOT_FAILURE:
            return {
                depthBots: [],
                loading: false,
                error: true,
            };

        default:
            return state;
    }
};

export default getDepthBot;
